import { theme } from "../../../config/theme";

const styles = {
  wrapper: {
    minWidth: 250,
    background: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.main}`,
    padding: "10px 10px 6px"
  },
  bold: {
    fontWeight: 600
  },
  flex: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 4
  },
  date: {
    marginBottom: 10
  }
};

export { styles };
